import { Switch } from '@/components/ui/switch';
import type { MetadataSchemaField } from '@/types/metadata.types';

interface SwitchFieldProps {
  field: MetadataSchemaField;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  disabled?: boolean;
}

export default function SwitchField({
  field,
  value,
  onChange,
  error: _error,
  disabled,
}: SwitchFieldProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch
        id={field.fieldKey}
        checked={!!value}
        onCheckedChange={onChange}
        disabled={disabled}
      />
      <span className="text-sm text-muted-foreground">
        {value ? 'Yes' : 'No'}
      </span>
    </div>
  );
}
